// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"92c2ad5b","328":"b377451b"}[chunkId] + ".chunk.js";
};